import script from "./ProviderDocumentsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderDocumentsSection.vue?vue&type=script&setup=true&lang=js"

import "./ProviderDocumentsSection.vue?vue&type=style&index=0&id=27afa5d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27afa5d6"]])

export default __exports__